import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from '../../shared/models';

/**
 * Service to handle shared functionality across the notifications component
 */
@Injectable()
export class NotificationsService {
  public openNotificationsModal$ = new Subject<Notification>();

  constructor() {}

  /**
   * Notifies the notification form modal to open
   */
  public openNotificationManagementModal (item?: Notification): void {
    this.openNotificationsModal$.next(item);
  }
}
